import { render } from "./AddCompetitorModal.vue?vue&type=template&id=09e8b1a6"
import script from "./AddCompetitorModal.vue?vue&type=script&lang=js"
export * from "./AddCompetitorModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__